import React from 'react';

import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';

import MlFormField from './MlFormField';

import './form.scss';

const TextInput = ({ label, error, hint, required, ref, ...inputProps }) => {
    const hasError = error && error.length > 0;

    return (
        <MlFormField
            label={label}
            name={inputProps.name}
            required={required}
            hint={hint}
            error={error}
        >
            <Form.Control
                ref={ref}
                type="text"
                isInvalid={hasError}
                {...inputProps}
            />
        </MlFormField>
    );
};

TextInput.propTypes = {
    label: PropTypes.string,
    error: PropTypes.string,
    hint: PropTypes.string,
    required: PropTypes.bool,
};

export default TextInput;
